var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Events } from '../../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../../System/Aop';
import { ViewManager } from '../../UI';
import { Commands } from '../../UI/Command';
import { ActionModelV5 } from '../Application';
import * as DOMPurify from 'dompurify';
var ViewManagerV5 = (function (_super) {
    __extends(ViewManagerV5, _super);
    function ViewManagerV5(inject) {
        if (inject === void 0) { inject = null; }
        return _super.call(this, inject) || this;
    }
    ViewManagerV5.prototype.removeViews = function (viewIds) {
        if (!viewIds) {
            return;
        }
        for (var _i = 0, viewIds_1 = viewIds; _i < viewIds_1.length; _i++) {
            var id = viewIds_1[_i];
            this.deleteView(id);
            this.models.deleteCascade(id);
        }
    };
    ViewManagerV5.prototype.createViews = function (viewIds) {
        var _this = this;
        if (!viewIds) {
            return;
        }
        var views = new Array();
        for (var _i = 0, viewIds_2 = viewIds; _i < viewIds_2.length; _i++) {
            var id = viewIds_2[_i];
            this.createNewView(id, views);
        }
        views.forEach(function (v) { return _this.viewLoad(v, views); });
    };
    ViewManagerV5.prototype.updateViews = function (viewIds) {
        if (!viewIds) {
            return;
        }
        for (var _i = 0, viewIds_3 = viewIds; _i < viewIds_3.length; _i++) {
            var id = viewIds_3[_i];
            this.updateView(id);
        }
    };
    ViewManagerV5.prototype.createNewView = function (id, views) {
        var _this = this;
        var model = this.models.getModel(id);
        if (!model) {
            throw new TypeError('Cannot create view from null model');
        }
        if (this.getView(model) === undefined) {
            this.viewResolver.resolve(model, function (view) {
                views.push(view);
                _this.viewCreated(view);
            });
        }
    };
    ViewManagerV5.prototype.getModel = function (key) {
        return this.models.getModel(key);
    };
    ViewManagerV5.prototype.ShowClientPrintersHandler = function (command) {
        this.event.publish(Events.DesktopAgentClientPrinters, command);
    };
    ViewManagerV5.prototype.PrintFileHandler = function (command) {
        this.event.publish(Events.DesktopAgentPrintFile, command);
    };
    ViewManagerV5.prototype.updateView = function (id) {
        var view = this.views.value(id);
        if (view) {
            var model = this.models.getModel(id);
            if (model['IsDisposed']) {
                this.deleteView(id);
                this.models.deleteCascade(id);
                return;
            }
        }
    };
    ViewManagerV5.prototype.initializeCommand = function () {
        var _this = this;
        _super.prototype.initializeCommand.call(this);
        this.registerCommand(Commands.OpenView, function (command) {
            return _this.openViewCommandHandler(command);
        });
        this.registerCommand(Commands.SendCommand, function (command) {
            return _this.sendCommandHandler(command);
        });
        this.registerCommand(Commands.PendingResponse, function (command) {
            return _this.pendingResponseHandler(command);
        });
        this.registerCommand(Commands.BringToFrontCommand, function (command) {
            return _this.bringToFrontHandler(command);
        });
        this.registerCommand(Commands.SessionExpiredCommand, function (command) {
            return _this.sessionExpiredHandler(command);
        });
        this.registerCommand(Commands.ChangeMenuCommand, function (command) {
            return _this.changeMenuHandler(command);
        });
        this.registerCommand(Commands.DownloadFileCommand, function (command) {
            return _this.downloadFileHandler(command);
        });
        this.registerCommand(Commands.ArrangeWindowCommand, function (command) {
            return _this.arrangeWindowHandler(command);
        });
        this.registerCommand(Commands.GridPrintCommand, function (command) {
            return _this.gridPrintHandler(command);
        });
        this.registerCommand(Commands.StartEditCommand, function (command) {
            return _this.startEditControlHandler(command);
        });
        this.registerCommand(Commands.StylesChangedCommand, function (command) {
            return _this.stylesChangedHandler(command);
        });
        this.registerCommand(Commands.UpdateRangesCommand, function (command) {
            return _this.updateRangesHandler(command);
        });
        this.registerCommand(Commands.ModalExecutionCommand, function (command) {
            return _this.modalExecutionHandler(command);
        });
        this.registerCommand(Commands.ShowClientPrintersCommand, function (command) {
            return _this.ShowClientPrintersHandler(command);
        });
        this.registerCommand(Commands.PrintFileCommand, function (command) {
            return _this.PrintFileHandler(command);
        });
    };
    ViewManagerV5.prototype.openViewCommandHandler = function (command) {
        var _this = this;
        var model = this.models.getModel(command.receiverId);
        if (this.getView(model) === undefined) {
            this.viewResolver.resolve(model, function (view) {
                view.load();
                _this.viewCreated(view);
            });
        }
    };
    ViewManagerV5.prototype.sendCommandHandler = function (command) {
        var actionModel = new ActionModelV5(command.receiverId, command.serverEvent, command.sender.name, command.action, command.args, command.callback, command.highPriority);
        this.action.send(actionModel);
    };
    ViewManagerV5.prototype.downloadFileHandler = function (command) {
        var url = "".concat(window.location.href).concat(command.downloadUrl);
        var downloadLink = document.createElement('a');
        downloadLink.setAttribute('download', command.key);
        var safeUrlT = DOMPurify.sanitize(url, { RETURN_DOM_FRAGMENT: true });
        downloadLink.setAttribute('href', safeUrlT.textContent);
        downloadLink.click();
    };
    ViewManagerV5.prototype.pendingResponseHandler = function (command) {
        var commandName = Commands.PendingResponse;
        var actionModel = new ActionModelV5(command.receiverId, command.serverEvent, commandName, command.action, command.args);
        actionModel.requestConfig.headers[command.action] = command.receiverId;
        this.action.send(actionModel);
    };
    ViewManagerV5.prototype.bringToFrontHandler = function (command) {
        var model = this.models.getModel(command.UniqueID);
        var view = this.getView(model);
        if (view !== undefined) {
            view.bringToFront();
        }
    };
    ViewManagerV5.prototype.sessionExpiredHandler = function (command) {
        var modal = this.modalFactory.create('expired');
        modal.show(command);
    };
    ViewManagerV5.prototype.gridPrintHandler = function (command) {
        this.event.publish(Events.GridPrint, command);
    };
    ViewManagerV5.prototype.stylesChangedHandler = function (command) {
        this.event.publish(Events.StylesChanged, command);
    };
    ViewManagerV5.prototype.updateRangesHandler = function (command) {
        this.event.publish(Events.UpdateRanges, command);
    };
    ViewManagerV5.prototype.modalExecutionHandler = function (command) {
        this.event.publish(Events.ModalExecution, command);
    };
    ViewManagerV5 = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], ViewManagerV5);
    return ViewManagerV5;
}(ViewManager));
export { ViewManagerV5 };
